export default __webpack_public_path__ + "static/media/icon-ajout-cata-thematique.6ca142f9.svg";